import { Injectable, Inject } from '@angular/core';
import { Constants } from '@app/common/constants';
import { HttpHelper } from '@app/common/http-helper';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Environment } from '@environments/interface.environment';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: Environment, private http: HttpClient) { }

  getAllTemplates(): Observable<any> {
    return this.http.get<any>(`${Constants.API_ENDPOINT}/Customers/Templates`,
      { withCredentials: true, observe: 'response' })
      .pipe(
        map(response => {
          return response;
        }),
        catchError(HttpHelper.handleError('getAllTemplates', '', true)));
  }

  getLibraryUrl(workSiteId: string, templateName: string): Observable<any> {
    return this.http.get(`${Constants.API_ENDPOINT}/Customers/${workSiteId}/Templates/${templateName}/LibraryUrl`,
      { withCredentials: true, observe: 'response', responseType: 'text' })
      .pipe(
        map(response => {
          return response;
        }),
        catchError(HttpHelper.handleError('getLibraryUrl', '', true)));
  }


  getSiteUrl(workSiteId: string): Observable<any> {
    return this.http.get(`${Constants.API_ENDPOINT}/Customers/${workSiteId}/Site`,
      { withCredentials: true, observe: 'response', responseType: 'text' })
      .pipe(
        map(response => {
          return response;
        }),
        catchError(HttpHelper.handleError('getSiteUrl', '', true)));
  }

  getAppliedTemplates(workSiteId: string): Observable<any> {
    return this.http.get(`${Constants.API_ENDPOINT}/Customers/${workSiteId}/Templates`,
      { withCredentials: true, observe: 'response', responseType: 'text' })
      .pipe(
        map(response => {
          return response;
        }),
        catchError(HttpHelper.handleError('getAppliedTemplates', '', true)));
  }

  getProvisioningStatus(workSiteId: string): Observable<any> {
    return this.http.get(`${Constants.API_ENDPOINT}/Customers/${workSiteId}/ProvisioningStatus`,
      { withCredentials: true, observe: 'response', responseType: 'text' })
      .pipe(
        map(response => {
          return response;
        }),
        catchError(HttpHelper.handleError('getProvisioningStatus', '', true)));
  }

  createSite(workSiteId: string): Observable<any> {
    return this.http.post(`${Constants.API_ENDPOINT}/Customers/${workSiteId}/Site`, '',
      { withCredentials: true, observe: 'response', responseType: 'text' })
      .pipe(
        map(response => {
          return response;
        }),
        catchError(HttpHelper.handleError('createSite', '', true)));
  }

  applyTemplate(workSiteId: string, templateName: string): Observable<any> {
    return this.http.post(`${Constants.API_ENDPOINT}/Customers/${workSiteId}/Templates/${templateName}`, '',
      { withCredentials: true, observe: 'response', responseType: 'text' })
      .pipe(
        map(response => {
          return response;
        }),
        catchError(HttpHelper.handleError('applyTemplate', '', true)));
  }

}
